module.exports = __webpack_public_path__ + "img/icon_practices.9af65e96.svg";